<template>
  <div>
    <el-form ref="form" size="mini" :model="data" status-icon :rules="formRules">
      <el-row class="item-title">
        <el-col :span="24">
          <span>商品价格是否体现税额</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="showTax">
            <el-radio-group v-model="data.showTax">
              <el-radio label="0">不含税</el-radio>
              <el-radio label="1">含税</el-radio>
            </el-radio-group>
          </el-form-item>
          <span>（不含税，则表示在商品信息中录入的价格不含税额）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>单据是否处理税金</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="disposeTax">
            <el-radio-group v-model="data.disposeTax">
              <el-radio label="0">不处理</el-radio>
              <el-radio label="1">处理</el-radio>
            </el-radio-group>
          </el-form-item>
          <span>（处理，则在销货单、其它收入单、费用单中显示票据类型供选择，并且列表显示不含税单价和金额）</span>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>销售时，最低售价是否管控</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="lowestPrice">
            <el-radio-group v-model="data.lowestPrice">
              <el-radio label="0">不管控</el-radio>
              <el-radio label="1">只提示</el-radio>
              <el-radio label="2">低于最低价，无法保存</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>销售时，最低成本是否管控</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="lowestCost">
            <el-radio-group v-model="data.lowestCost">
              <el-radio label="0">不管控</el-radio>
              <el-radio label="1">只提示</el-radio>
              <el-radio label="2">低于最低价，无法保存</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>扫描商品条码时，若商品相同，是否进行合并</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="merge">
            <el-radio-group v-model="data.merge">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="item-title">
        <el-col :span="24">
          <span>单据录入时，商品明细重复，是否进行提示</span>
        </el-col>
      </el-row>
      <el-row class="item-content">
        <el-col :span="24">
          <el-form-item prop="prompt">
            <el-radio-group v-model="data.prompt">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-alert title="数据保存成功后，需要重新登录才能生效" type="warning" :closable="false" />
    <div class="item-footer">
      <el-button type="primary" size="mini" style="width:80px;" @click="submit">保 存</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: {
        showTaxId: 0,
        showTax: null, //商品价格是否体现税额
        disposeTaxId: 0,
        disposeTax: null, //单据是否处理税金
        lowestPriceId: 0,
        lowestPrice: null, //销售时，最低售价是否管控
        lowestCostId: 0,
        lowestCost: null, //销售时，最低成本是否管控
        mergeId: 0,
        merge: null, //扫描商品条码时，若商品相同，是否进行合并
        promptId: 0,
        prompt: null, //单据录入时，商品明细重复，是否进行提示
      },
      isNull: false,
      saveData: [],
      formRules: {
        showTax: [{ required: true, message: "请选择" }],
        disposeTax: [{ required: true, message: "请选择" }],
        lowestPrice: [{ required: true, message: "请选择" }],
        lowestCost: [{ required: true, message: "请选择" }],
        merge: [{ required: true, message: "请选择" }],
        prompt: [{ required: true, message: "请选择" }],
      },
      api: require("@/api/sy/opt").default,
    };
  },
  methods: {
    getData() {
      this.api.list({ Code: "SALE" }).then((res) => {
        
        if (res.Data.length == 0) {
          this.isNull = true;
        }
        res.Data.forEach((item) => {
          switch (item.OptText) {
            case "ShowTax":
              this.data.showTaxId = item.OptId;
              this.data.showTax = item.OptValue;
              break;
            case "DisposeTax":
              this.data.disposeTaxId = item.OptId;
              this.data.disposeTax = item.OptValue;
              break;
            case "LowestPrice":
              this.data.lowestPriceId = item.OptId;
              this.data.lowestPrice = item.OptValue;
              break;
            case "LowestCost":
              this.data.lowestCostId = item.OptId;
              this.data.lowestCost = item.OptValue;
              break;
            case "Merge":
              this.data.mergeId = item.OptId;
              this.data.merge = item.OptValue;
              break;
            case "Prompt":
              this.data.promptId = item.OptId;
              this.data.prompt = item.OptValue;
              break;
          }
        });
      });
    },
    submit() {
      let form = this.formValidate();
      form.then((valid) => {
        if (!valid) return;
        this.saveData = [];

        this.saveData.push({
          OptId: this.data.showTaxId,
          Code: "SALE",
          OptValue: this.data.showTax,
          OptText: "ShowTax",
        });
        this.saveData.push({
          OptId: this.data.disposeTaxId,
          Code: "SALE",
          OptValue: this.data.disposeTax,
          OptText: "DisposeTax",
        });
        this.saveData.push({
          OptId: this.data.lowestPriceId,
          Code: "SALE",
          OptValue: this.data.lowestPrice,
          OptText: "LowestPrice",
        });
        this.saveData.push({
          OptId: this.data.lowestCostId,
          Code: "SALE",
          OptValue: this.data.lowestCost,
          OptText: "LowestCost",
        });
        this.saveData.push({
          OptId: this.data.mergeId,
          Code: "SALE",
          OptValue: this.data.merge,
          OptText: "Merge",
        });
        this.saveData.push({
          OptId: this.data.promptId,
          Code: "SALE",
          OptValue: this.data.prompt,
          OptText: "Prompt",
        });

        if (this.isNull) {
          this.api.save(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.isNull = false;
              this.$message.success("保存成功");
            }
          });
        } else {
          this.api.update(this.saveData).then((res) => {
            if (res.Code == 1) {
              this.$message.error(res.Msg);
            } else {
              this.$message.success("保存成功");
            }
          });
        }
      });
    },
    formValidate() {
      return this.$refs.form
        .validate()
        .then((valid) => {
          return valid;
        })
        .catch(() => {
          this.$notify({
            title: "提示",
            message: "请检查相关字段（红色）填写是否规范",
            type: "warning",
            position: "top-left",
          });
          return false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.item-title {
  margin-bottom: 10px;
  span {
    font-size: 18px;
    color: #606266;
  }
}
.item-content {
  margin-bottom: 30px;
  span {
    font-size: 14px;
    line-height: 29px;
    float: left;
    margin-right: 12px;
    color: #606266;
  }
}
.item-footer {
  margin-top: 10px;
  padding: 10px 20px 20px;
  text-align: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-top: 1px solid #e4e7ed;
}
.el-alert {
  padding-left: 5px;
  background: #cae2ff;
  color: #606266;
}
.el-form {
  padding: 0px 13px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
  margin-right: 40px;
  float: left;
}
</style>